import { Component, Input, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { downloadHelper } from 'src/app/helper/class/downloadHelper';
import {
  formBuilderData,
  formDynamicValidator,
  ResponseData,
} from 'src/app/helper/interface/response';
import { AlertService } from 'src/app/helper/service/alert.service';
import { ReportApiService } from 'src/app/modules/report/service/report-api.service';
import { FormGeneratorComponent } from 'src/app/shared/form/component/form-generator/form-generator.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EditorModule } from 'src/app/editor/editor.module';
import { ImageUploadModule } from 'src/app/shared/shared.module';
import { FormHelperModule } from 'src/app/shared/form/form-hepler.module';

@Component({
  selector: 'app-export-excel-templates',
  templateUrl: './export-excel-templates.component.html',
  styleUrls: ['./export-excel-templates.component.scss'],
  standalone:true,
  imports:[ CommonModule,
      ReactiveFormsModule,
      EditorModule,
      ImageUploadModule,
      FormHelperModule,
      ]
})
export class ExportExcelTemplatesComponent {
  module = '';
  @Input() pageMode: 'DIRECT' | 'PAGE' = 'DIRECT';
  loading: boolean = false;
   public onClose: Subject<any> = new Subject();
  basicFormData: formBuilderData[] = [];
  templateFormData: formBuilderData[] = [
    {
      colName: 'module',
      title: 'Report Type',
      type: 'select',
      event: {
        name: 'change',
        apiFunName: 'getReportTemplateByModule',
        valueAssign: 'code',
      },
      apiFunName: 'getExportModule',
      selectKeyName: 'moduleName',
      selectPrimaryKey: 'module',
    },
    {
      colName: 'code',
      title: 'Template',
      validator: [{ name: 'required' }],
      event: { name: 'change', isCallback: true },
      selectKeyName: 'template_name',
      type: 'select',
    },
  ];
  filterFormData: formBuilderData[] = [];
  loadForm: boolean = false;
  dynamicValidator: formDynamicValidator[] = [];
  @ViewChild('basicForm') basicForm: FormGeneratorComponent | undefined;
  @ViewChild('templateForm') templateForm: FormGeneratorComponent | undefined;
  @ViewChild('filterForm') filterForm: FormGeneratorComponent | undefined;
  @ViewChild('sponsorForm') sponsorForm: FormGeneratorComponent | undefined;
  templateList: any = [];
  selectedTemplate: any = {};
  globalCondition = {};
  constructor(
    private reportApi: ReportApiService,
    private alertService: AlertService,
     private _bsModalRef: BsModalRef,
    private downloadHelper: downloadHelper,
  ) {}

  ngOnInit(): void {}

  setInput(config) {
    this.pageMode = 'DIRECT';
    if(config.code){
      this.getTemplateByCode(config.code);
    }
    this.globalCondition = config?.condition || [];
  }

  getTemplateByCode(code) {
    this.reportApi
      .getTemplateByCode(code)
      .then((res: ResponseData) => {
        this.toSelectTemplate(res.result)
      });
  }
  formGenerateTemplateList() {
    if (this.selectedTemplate?.id) {
      const formData: formBuilderData[] = [];
      if (this.selectedTemplate.sections) {
        this.selectedTemplate.sections.forEach((section) => {
          const formControl: formBuilderData = {
            colName: section.id,
            title: section.name,
            type: 'MULTISELECT',
            selectKeyName: 'label',
            selectPrimaryKey: 'field',
            data: section.columns,
          };
          formData.push(formControl);
        });
      }
      this.basicFormData = formData;
    }
  }
  filterFormGenerate() {
    if (this.selectedTemplate?.filter_config) {
      const filterForm: formBuilderData[] = [];
      this.selectedTemplate?.filter_config.forEach((filter) => {
        filterForm.push(filter);
      });
      this.filterFormData = filterForm;
      this.dynamicValidator = this.selectedTemplate?.dynamic_config || [];
    }
  }
  forcedToDownload(){
    if(!this.basicFormData?.length && !this.filterFormData?.length){
    this.onSubmit();
    }
  }
  makeSelectedTemplate(code) {
    this.wipeForm();
    this.templateList = this.templateForm?.getSupportData('code');
    setTimeout(() => {
      this.toSelectTemplate(this.templateList.find((a) => a.id == code))
    }, 100);
  }

  toSelectTemplate(template){
    this.wipeForm();
    setTimeout(() => {
      this.selectedTemplate =template;
      this.formGenerateTemplateList();
      this.filterFormGenerate();
      this.forcedToDownload();
    }, 300);
  }

  onChange(ev: any) {
    if (ev?.controlName == 'code') {
      this.makeSelectedTemplate(ev.value);
    }
  }

  wipeForm() {
    this.basicFormData = [];
    this.filterFormData = [];
  }

  get isValid() :boolean {
    return  this.basicForm?.isValid();
  }

  payload(d: any = null) {
    const payload: any = {};
    payload.userSelection = this.basicForm?.apiPayload();
    const filters = this.filterForm?.apiPayload() || {};
    payload.filters = {...this.globalCondition || {},...filters};
    // this.filterFormData.forEach((e) => {
    //   if (filters[e.colName]) {
    //     payload.filters[e.colName] = filters[e.colName];
    //   }
    // });
    
    payload.code = this.selectedTemplate?.code;
    return payload;
  }

  onSubmit(
    module: any = this.module,
    apiPayload = this.payload(),
  ): Promise<any> {
     console.log('payload ', this.filterForm?.getFormValue(),apiPayload);
    return new Promise((resolve, reject) => {
      this.loading = true;
      this.reportApi
        .exportReport(this.selectedTemplate.code, apiPayload)
        .then(async (res: any) => {
          this.downloadHelper.downloadFile(res);
          // this.basicForm?.reset();
          resolve(true);
        })
        .catch((err) =>
          this.alertService.showToast('Unable to download Report', 'info'),
        )
        .finally(() => {
          this.loading = false;
        });
    });
  }

  close() {
    if(this.pageMode=='DIRECT'){
      this._bsModalRef?.hide();
      this.onClose.next({sent:true});
    }
  }
}
